import './styles.css';
import './mobile-controls.css';
import './mobile-composition.css';
import './developer-graphics.css';
import { renderArtDirectionBoard } from './renderArtDirectionBoard';
import { renderGame } from './game';

const mount = document.querySelector<HTMLElement>('#app');
if (!mount) throw new Error('Application mount is missing.');

const view = new URLSearchParams(window.location.search).get('view');
if (view === 'art-direction-board') {
  renderArtDirectionBoard(mount);
} else if (view === 'gate-3' || view === 'gate-2' || view === null) {
  renderGame(mount);
} else {
  mount.innerHTML = '<section class="landing"><h1>View not found</h1><a href="/?view=gate-3">Return to Gate 3 encounter</a></section>';
  document.documentElement.dataset.captureReady = 'true';
}
